export default __webpack_public_path__ + "images/878e6d524d1e0c7b073332a7622b75ff.jpg";